import { PAYMENT_BASE_URL } from "../constants/constants";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";

export const createPaymentIntent = async(amount, currency) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/create-payment-intent`, {
            amount: amount,
            currency: currency
        });

        console.log(response);
        return { success: true, clientSecret: response.data.clientSecret };
    }catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}

export const createStripeUser = async(email) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/create-customer`, {
            email: email
        });

        console.log(response);
        return { success: true, data: response.data };
    }catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}

export const createSubscription = async(stripeCustomerId, priceId, paymentMethodId, credits, planPriceUSD) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/create-subscription`, {
            stripeCustomerId: stripeCustomerId,
            priceId: priceId,
            paymentMethodId: paymentMethodId,
            credits: credits,
            planPriceUSD: planPriceUSD
        });

        console.log(response);
        return { success: true, data: response.data };
    }catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}

export const getPaymentMethods = async(stripeCustomerId) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/payment-methods`, {
            stripeCustomerId: stripeCustomerId
        });
        console.log(response);
        return { success: true, paymentMethods: response.data.paymentMethods, defaultPaymentMethodId: response.data.defaultPaymentMethodId};
    } catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}

export const makeDefaultPaymentMethod = async(stripeCustomerId, paymentMethodId) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/make-default-card`, {
            stripeCustomerId: stripeCustomerId,
            paymentMethodId: paymentMethodId
        });
        console.log(response);
        return true;
    } catch(error){
        console.log(error);
        return false;
    }
}

export const createSetupIntent = async(stripeCustomerId) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/create-setup-intent`, {
            stripeCustomerId: stripeCustomerId
        });
        console.log(response);
        return { success: true, clientSecret: response.data.clientSecret};
    } catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}

export const deletePaymentMethod = async(stripeCustomerId, paymentMethodId) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/delete-payment-method`, {
            stripeCustomerId: stripeCustomerId,
            paymentMethodId: paymentMethodId
        });
        console.log(response);
        return { success: true, message: response.data};
    } catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}

export const cancelCurrentSubscription = async(stripeCustomerId) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/cancel-subscription`, {
            stripeCustomerId: stripeCustomerId
        });
        console.log(response);
        return { success: true, message: response.data};
    } catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}

export const getInvoiceItems = async(stripeCustomerId) => {
    try{
        const response = await axiosRequestInterceptor.post(`payment/get-invoices`, {
            stripeCustomerId: stripeCustomerId
        });
        console.log(response);
        return { success: true, invoiceItems: response.data.invoices};
    } catch(error){
        console.log(error);
        return { success: false, error: error.response.data.error};
    }
}